import { AcademicCapIcon, BriefcaseIcon, CheckCircleIcon, ClipboardDocumentCheckIcon, DocumentTextIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { HeroIcon, NavTreeItem } from "../../../components/common/navigation";
import { UserRole } from "../../../models/user.model";
import { useCertificatesFaqTree } from "../topics/certificates/useCertificatesFaqTree";
import { useProfessionalSummaryFaqTree } from "../topics/professional-summary/useProfessionalSummaryFaqTree";
import { useProfileCompletionFaqTree } from "../topics/profile-completion/hooks/useProfileCompletionFaqTree";
import { useSearchFaqTree } from "../topics/search/useSearchFaqTree";
import { useSkillsMatrixFaqTree } from "../topics/skills-matrix/useSkillsMatrixFaqTree";
import { useWorkVsProjectExperienceFaqTree } from "../topics/work-vs-project-experience/useWorkVsProjectExperienceFaqTree";

// The single extension point for FAQ topics — adding a topic means adding one
// entry here plus that topic's own module, no changes to Faq.tsx or SideNavTree.
export interface FaqTopicDefinition {
    id: string;
    label: string;
    icon: HeroIcon;
    requiredRoles: UserRole[];
    useTopicTree: () => NavTreeItem | null;
}

export const FAQ_TOPICS: FaqTopicDefinition[] = [
    {
        id: "profile-completion",
        label: "Profile Completion",
        icon: CheckCircleIcon,
        requiredRoles: [UserRole.User, UserRole.Manager, UserRole.Admin],
        useTopicTree: useProfileCompletionFaqTree,
    },
    {
        id: "search",
        label: "Search",
        icon: MagnifyingGlassIcon,
        requiredRoles: [UserRole.User, UserRole.Manager, UserRole.Admin],
        useTopicTree: useSearchFaqTree,
    },
    {
        id: "certificates",
        label: "Certificates",
        icon: AcademicCapIcon,
        requiredRoles: [UserRole.User, UserRole.Manager, UserRole.Admin],
        useTopicTree: useCertificatesFaqTree,
    },
    {
        id: "skills-matrix",
        label: "Skills Self-Assessment",
        icon: ClipboardDocumentCheckIcon,
        requiredRoles: [UserRole.User, UserRole.Manager, UserRole.Admin],
        useTopicTree: useSkillsMatrixFaqTree,
    },
    {
        id: "professional-summary",
        label: "Professional Summary",
        icon: DocumentTextIcon,
        requiredRoles: [UserRole.User, UserRole.Manager, UserRole.Admin],
        useTopicTree: useProfessionalSummaryFaqTree,
    },
    {
        id: "work-vs-project-experience",
        label: "Work Experience vs Project Experience",
        icon: BriefcaseIcon,
        requiredRoles: [UserRole.User, UserRole.Manager, UserRole.Admin],
        useTopicTree: useWorkVsProjectExperienceFaqTree,
    },
];


